import { render, staticRenderFns } from "./EventsCorner.vue?vue&type=template&id=5ccb0391"
import script from "./EventsCorner.vue?vue&type=script&lang=js"
export * from "./EventsCorner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports